<div class="qb-center" style="padding: 12px;flex-direction: column;gap:16px;height:200px">
    <mat-spinner diameter="30">
    
    </mat-spinner>
    <div>Redirecting to {{data["platform"]}} website... </div>
   
</div>